export const CONTENT_RESIZE = '@content-resize';


export const onResize = (payload = {}) => {
    window.top.postMessage({payload}, '*');
    return {
        payload,
        type: CONTENT_RESIZE
    };
};
